import { CalculatorIcon, CheckBadgeIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { DateInputFormat } from "@/components/common/DateComponents";
import { useState } from "react";
import { connect } from "react-redux";
import { useMemo } from "react";

import { Actions as LEAVEADJUSTMENTACTIONS } from "../../store/actions/leaveAdjustmentActions";

import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";

const CalculateBackdatedPHModal = ({ org, calculateBackdatePH, planHasAccess }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [publicHoliday, setPublicHoliday] = useState(new Date());

	//Calculate backdated public holidays
	const calculate = () => {
		if (!publicHoliday)
			return NotificationManager.error(
				"Public Holiday Date cannot be left empty!",
				"Calculate Backdated Public Holidays",
			);
		calculateBackdatePH(org, publicHoliday);
		setIsOpen(false);
	};

	//Restore to defaults when modal is opened
	useMemo(() => {
		if (!isOpen) return;
		setPublicHoliday(new Date());
	}, [isOpen]);

	//Return if plan is not Automation Guru or Seriously Accurate
	if (!planHasAccess) return null;

	return (
		<>
			<button
				type="button"
				className="btn btn-default pull-right mr-4"
				onClick={() => setIsOpen(true)}
			>
				<CalculatorIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
				<div style={{ float: "left" }}>Calculate Backdated Public Holidays</div>
			</button>
			<div
				className="modal"
				tabIndex="-1"
				role="dialog"
				aria-hidden={!isOpen}
				style={{
					visibility: isOpen ? "visible" : "hidden",
					display: "block",
					background: "rgba(0,0,0,0.4)",
					overflow: "scroll",
					// transition: "opacity 0.5s ease-in-out, visibility 0.5s ease-in-out",
					opacity: isOpen ? 1 : 0,
					pointerEvents: isOpen ? "auto" : "none",
				}}
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div
							className="block block-themed block-transparent remove-margin-b"
							style={{ padding: 0 }}
						>
							<div
								className="block-header bg-primary-dark"
								style={{ padding: 20 }}
							>
								<ul className="block-options">
									<li>
										<button
											type="button"
											onClick={() => setIsOpen(false)}
										>
											<XMarkIcon className="h-6 w-6 mr-3 text-white" />
										</button>
									</li>
								</ul>
								<h3 className="block-title text-white">Calculate Backdated Public Holidays</h3>
							</div>
							<div
								className="block-content"
								style={{ padding: 20 }}
							>
								<div
									className="col-sm-12"
									style={{ paddingBottom: 10, paddingLeft: 0 }}
								>
									<div
										className="col-xs-5"
										style={{ padding: 0 }}
									>
										<label>Public Holiday Date*</label>
										<DatePicker
											wrapperClassName="full-width"
											selected={publicHoliday}
											onChange={(date) => setPublicHoliday(date)}
											dateFormat="dd/MM/yyy"
											popperPlacement="bottom-start"
											customInput={<DateInputFormat />}
										/>
									</div>
								</div>
								<div
									className="col-sm-12"
									style={{ paddingBottom: 10, paddingLeft: 0, paddingRight: 0 }}
								>
									<div
										className="btn btn-success pull-right"
										onClick={calculate}
									>
										<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<span style={{ float: "left" }}>Calculate</span>
									</div>
									<div
										className="btn btn-danger pull-right"
										style={{ marginRight: 5 }}
										onClick={() => setIsOpen(false)}
									>
										Cancel
									</div>
								</div>
							</div>
							<div className="clearfix" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const plan = state?.company?.settings?.plan;

	return {
		org: state?.company?.settings?.org,
		planHasAccess: ["f4ea1f9f-dc37-4197-9261-987ef1147f14", "927ccff3-b2fb-42b4-809c-2a15b593770b"].includes(plan),
	};
};

const mapDispatchToProps = (dispatch) => ({
	calculateBackdatePH: (org, publicHoliday) =>
		dispatch(LEAVEADJUSTMENTACTIONS.calculateBackdatePH(org, publicHoliday)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalculateBackdatedPHModal);
